import { IKunde } from '../mgs.types';
import { getFormattedDateString, htmlOut } from '@mng/mng-ts-helpers';

export function getKundeInfoAsString(
  kunde: IKunde,
  options?: { withKundenNr?: boolean; withGeburtsDatum?: boolean }
): string {
  if (!kunde) {
    return '';
  }
  const kundenNr = options?.withKundenNr && kunde.kundennr ? `${kunde.kundennr}, ` : '';
  const geburtsDatum =
    options?.withGeburtsDatum && kunde.geburtsDatum ? `, ${getFormattedDateString(kunde.geburtsDatum)}` : '';

  return `${kundenNr}${kunde.name} ${kunde.vorname ?? ''} ${kunde.titel ?? ''}${geburtsDatum}`;
}

export function kundeInfoHtmlDetailAsString(
  kunde: IKunde,
  options?: { withKundenNr?: boolean; withGeburtsDatum?: boolean; withId?: boolean }
): string {
  if (!kunde) {
    return '';
  }
  const kundenNr = options?.withKundenNr && kunde.kundennr ? htmlOut('Kundenr', kunde.kundennr) : '';
  const geburtsDatum =
    options?.withGeburtsDatum && kunde.geburtsDatum
      ? htmlOut('Geb. Datum', getFormattedDateString(kunde.geburtsDatum))
      : '';
  const id = options?.withId ? htmlOut('ID', kunde.id) : '';

  const titel = kunde.titel ? htmlOut('Titel', kunde.titel) : '';

  return `<div style='min-width: 200px'>
          ${htmlOut('Name', kunde.name)}
          ${htmlOut('Vorname', kunde.vorname)}
          ${titel}
          ${kundenNr}
          ${geburtsDatum}
          ${id}
          </div>
`;
}
